import formatIndexFromHtml from 'commons/js/util/formatIndexFromHtml'

formatIndexFromHtml('terms-content', 'terms-content-index')
